app.directive('navbar', function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        templateUrl: _pb + 'components/navbar/navbar.html',
        link: function (scope) {

        }
    };
});